<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d8e3d221">Contents</p>
<p class="cct" id="d8e3221"><a href="#/Wise_9781401685553_epub_c6.5_r1#d7e1" id="d6e1">Pennsylvania Dutch Glossary</a></p>
<p class="cct" id="d8e5811"><a href="#/Wise_9781401685553_epub_c7_r1#d7e2" id="d6e2">1</a></p>
<p class="cct" id="d8e25231"><a href="#/Wise_9781401685553_epub_c8_r1#d7e3" id="d6e3">2</a></p>
<p class="cct" id="d8e49511"><span href="#/Wise_9781401685553_epub_c9_r1#d7e4" id="d6e4" title="Link target outside of Sample">3</span></p>
<p class="cct" id="d8e75811"><span href="#/Wise_9781401685553_epub_c10_r1#d7e5" id="d6e5" title="Link target outside of Sample">4</span></p>
<p class="cct" id="d8e100001"><span href="#/Wise_9781401685553_epub_c11_r1#d7e6" id="d6e6" title="Link target outside of Sample">5</span></p>
<p class="cct" id="d8e126241"><span href="#/Wise_9781401685553_epub_c12_r1#d7e7" id="d6e7" title="Link target outside of Sample">6</span></p>
<p class="cct" id="d8e145851"><span href="#/Wise_9781401685553_epub_c13_r1#d7e8" id="d6e8" title="Link target outside of Sample">7</span></p>
<p class="cct" id="d8e165871"><span href="#/Wise_9781401685553_epub_c14_r1#d7e9" id="d6e9" title="Link target outside of Sample">8</span></p>
<p class="cct" id="d8e184511"><span href="#/Wise_9781401685553_epub_c15_r1#d7e10" id="d6e10" title="Link target outside of Sample">9</span></p>
<p class="cct" id="d8e214741"><span href="#/Wise_9781401685553_epub_c16_r1#d7e11" id="d6e11" title="Link target outside of Sample">10</span></p>
<p class="cct" id="d8e237171"><span href="#/Wise_9781401685553_epub_c17_r1#d7e12" id="d6e12" title="Link target outside of Sample">11</span></p>
<p class="cct" id="d8e254371"><span href="#/Wise_9781401685553_epub_c18_r1#d7e13" id="d6e13" title="Link target outside of Sample">12</span></p>
<p class="cct" id="d8e270921"><span href="#/Wise_9781401685553_epub_c19_r1#d7e14" id="d6e14" title="Link target outside of Sample">13</span></p>
<p class="cct" id="d8e289961"><span href="#/Wise_9781401685553_epub_c20_r1#d7e15" id="d6e15" title="Link target outside of Sample">14</span></p>
<p class="cct" id="d8e309351"><span href="#/Wise_9781401685553_epub_c21_r1#d7e16" id="d6e16" title="Link target outside of Sample">15</span></p>
<p class="cct" id="d8e323261"><span href="#/Wise_9781401685553_epub_c22_r1#d7e17" id="d6e17" title="Link target outside of Sample">16</span></p>
<p class="cct" id="d8e341481"><span href="#/Wise_9781401685553_epub_c23_r1#d7e18" id="d6e18" title="Link target outside of Sample">17</span></p>
<p class="cct" id="d8e359551"><span href="#/Wise_9781401685553_epub_c24_r1#d7e19" id="d6e19" title="Link target outside of Sample">18</span></p>
<p class="cct" id="d8e379751"><span href="#/Wise_9781401685553_epub_c25_r1#d7e20" id="d6e20" title="Link target outside of Sample">19</span></p>
<p class="cct" id="d8e393021"><span href="#/Wise_9781401685553_epub_c26_r1#d7e21" id="d6e21" title="Link target outside of Sample">Epilogue</span></p>
<p class="cct" id="d8e401041"><span href="#/Wise_9781401685553_epub_c27_r1#d7e22" id="d6e22" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cct" id="d8e403751"><span href="#/Wise_9781401685553_epub_c28_r1#d7e23" id="d6e23" title="Link target outside of Sample">Reading Group Guide</span></p>
<p class="cct" id="d8e409741"><span href="#/Wise_9781401685553_epub_c30_r1#d7e24" id="d6e24" title="Link target outside of Sample">Author to Author</span></p>
<p class="cct" id="d8e428501"><span href="#/Wise_9781401685553_epub_c35_r1#d7e25" id="d6e25" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wise_9781401685553_epub_c6_r1.vue?109e069f